import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { getPortalGate, PORTAL_GATE_PATH } from '@/access/portal-access'
import { isAdmin } from '@/hooks/use-is-admin'
import { store } from '@/store'

export const Route = createFileRoute('/_auth')({
  component: AuthLayout,
  beforeLoad: async () => {
    const state = store.getState()
    if (!state.isInitialized) {
      await state.initialize()
    }
    const currentState = store.getState()
    if (currentState.isAuthorized) {
      // `getPortalGate` lets admins through, so they land in the admin area; only
      // non-admins are routed to the beta-locked / terms screens.
      const gate = getPortalGate(currentState.partner)
      if (gate.kind !== 'allow') {
        throw redirect({
          to: PORTAL_GATE_PATH(gate),
          replace: true,
        })
      }
      throw redirect({
        to: isAdmin() ? '/admin/partners' : '/dashboard',
        replace: true,
      })
    }
  },
})

function AuthLayout() {
  return <Outlet />
}
